import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  SideBarStudentItem,
  StudentSideBarItemType,
} from '../../side-bar-user/componenets/side-bar-student-item';
import '../../side-bar-user/componenets/side-bar-student-item.css';
import { SideBarUserProfile } from './components/side-bar-user-profile';

export const SideBarStudent = () => {
  const navigate = useNavigate();
  const onClick = (path: string) => {
    const absolutePath = path.startsWith('/') ? path : `/${path}`;
    navigate(absolutePath);
  };

  return (
    <div
      style={{
        width: '254px',
        marginLeft: '16px',
        minWidth: '254px',
        maxWidth: '254px',
        direction: 'rtl',
        height: '100vh',
        backgroundColor: '#ffffff',
        position: 'sticky',
        top: 0,
        left: 0,
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '1px 0 2px rgba(0, 0, 0, 0.05)',
        zIndex: 1000,
        borderLeft: '1px solid var(--surface-200)',
      }}
    >
      {/* Portal Header */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '16px',
          borderBottom: '1px solid var(--surface-200)',
          backgroundColor: '#ffffff',
        }}
      >
        <div
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '12px',
            overflow: 'hidden',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            backgroundColor: 'var(--primary-color)',
          }}
        >
          <i
            className="pi pi-user"
            style={{ color: 'white', fontSize: '1rem' }}
          />
        </div>
        <span
          style={{
            fontFamily: "'Heebo', sans-serif",
            fontSize: '0.95rem',
            fontWeight: 500,
            position: 'relative',
            animation: 'shimmerRightToLeft 4s ease-in-out infinite',
            opacity: 0.9,
          }}
        >
          פורטל סטודנטים
        </span>
      </div>

      {/* Sidebar Content */}
      <div
        style={{
          flex: 1,
          overflow: 'auto',
          paddingRight: '16px',
          paddingLeft: '16px',
          paddingTop: '16px',
        }}
      >
        <div className="sidebar-section">
          <h3 className="section-title">מידע אישי</h3>
          <SideBarStudentItem
            type={StudentSideBarItemType.PROFILE}
            text={'פרטים אישיים'}
            onClick={() => onClick('student/profile')}
          />
        </div>

        <div className="sidebar-section">
          <h3 className="section-title">לימודים</h3>
          <SideBarStudentItem
            type={StudentSideBarItemType.ACADEMIC}
            text={'תוכניות לימודים'}
            onClick={() => onClick('student/programs')}
          />
          <SideBarStudentItem
            type={StudentSideBarItemType.COURSES}
            text={'קורסים'}
            onClick={() => onClick('student/courses')}
          />
          <SideBarStudentItem
            type={StudentSideBarItemType.LECTURES}
            text={'מפגשי השבוע'}
            onClick={() => onClick('student/lectures')}
          />
          <SideBarStudentItem
            type={StudentSideBarItemType.ASSIGNMENTS}
            text={'מטלות'}
            onClick={() => onClick('student/assignments')}
          />
          <SideBarStudentItem
            type={StudentSideBarItemType.EXAMS}
            text={'מבחנים'}
            onClick={() => onClick('student/exams')}
          />
          <SideBarStudentItem
            type={StudentSideBarItemType.COURSE_FEEDBACKS}
            text={'משובים למרצים'}
            onClick={() => onClick('student/course-feedbacks')}
          />
          <SideBarStudentItem
            type={StudentSideBarItemType.EXTERNAL_EXAMS}
            text={'מבחנים חיצוניים'}
            onClick={() => onClick('student/external-exams')}
          />
        </div>

        <div className="sidebar-section">
          <h3 className="section-title">שירותים</h3>
          <SideBarStudentItem
            type={StudentSideBarItemType.DOCS}
            text={'מסמכים'}
            onClick={() => onClick('student/documents')}
          />
          <SideBarStudentItem
            type={StudentSideBarItemType.PAYMENT_SERVICES}
            text={'שרותי תשלום'}
            onClick={() => onClick('student/payment-services')}
          />
        </div>
      </div>

      <SideBarUserProfile />
    </div>
  );
};
